import { createQuery } from '@amzn/gsce-shared-react-lib';
import type { ListTagsRequest, ListTagsResponse } from 'src/types/helios/Tags';
import { tagService, withRetry } from '../index';
import { TagQueryKeys } from './keys';

/**
 * Query hook for listing tags scoped to a business unit + program.
 *
 * Uses the legacy REST `tagService` (raw endpoint) rather than the typed
 * Helios SDK client: the tags API returns epoch-number `createdAt`/
 * `lastUpdatedAt` strings which fail the Smithy RFC-3339 deserializer — the
 * typed command would throw on deserialize, leaving the query in `error` with
 * `data === undefined` even on a 200. Same reason `useCategoriesQuery` /
 * `useQuestionQuery` wrap their raw services.
 *
 * Tags are BU + program scoped (matching the manual question flow's
 * `loadTags({ businessUnitId, programId, isActive })`). Callers own `enabled`
 * gating on `businessUnitId` / `programId`.
 */
export const useTagsQuery = createQuery<ListTagsRequest, ListTagsResponse>(
  TagQueryKeys.list,
  (input: ListTagsRequest): Promise<ListTagsResponse> =>
    withRetry(() => tagService.getAll(input)),
);
